import React from 'react';
import tpl from '../templates/double_salary.jsx';
import {View} from 'MWComponents';

export default class extends View {
    template = tpl;

    static displayName = 'DoubleSalary.Views.Main';
}
